import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import ImageRule1 from "@/assets/custom-digital-human-rule/image_rule_2.webp";
import ImageRule2 from "@/assets/custom-digital-human-rule/image_rule_2@2x.webp";
import ImageRule3 from "@/assets/custom-digital-human-rule/image_rule_2@3x.webp";

export const ImageRule2Image = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[ImageRule3]}
      {...props}
    />
  );
};

ImageRule2Image.displayName = 'ImageRule2Image';
